/**
 * Utility functions for map route detection and management
 */

/**
 * Check if a given URL/path is a map page
 * @param url - The URL or path to check
 * @returns boolean indicating if this is a map page
 */
export const isMapPage = (url: string): boolean => url.includes('/surf-reports-forecasts-cams');

/**
 * Check if current page is a map page using router
 * @param asPath - Router's asPath property
 * @returns boolean indicating if current page is a map page
 */
export const isCurrentPageMap = (asPath: string): boolean => isMapPage(asPath);

/**
 * Check if current page is a map page using window location
 * Useful when you need to check the current URL outside of React context
 * @returns boolean indicating if current page is a map page
 */
export const isCurrentPageMapFromWindow = (): boolean => {
  if (typeof window === 'undefined') return false;
  return isMapPage(window.location.pathname);
};
